var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Riichicitystore"},[_c('main',[_c('img',{attrs:{"src":require("@/assets/image/home/riichicitystore/loading_logo.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.$t("riichicitystore.p2")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }